var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogsMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 15.4913C2.42283 15.4913 0.333496 13.4019 0.333496 10.8246C0.333496 8.24726 2.42283 6.15792 5.00016 6.15792H12.419C12.6791 6.15792 12.7733 6.185 12.8684 6.23584C12.9635 6.28667 13.0381 6.36128 13.0889 6.45634C13.1398 6.5514 13.1668 6.6457 13.1668 6.90572V14.7435C13.1668 15.0035 13.1398 15.0978 13.0889 15.1928C13.0381 15.2879 12.9635 15.3625 12.8684 15.4133C12.7733 15.4642 12.6791 15.4913 12.419 15.4913H9.66683C9.66683 16.4044 10.02 17.3814 10.4279 17.8709C11.0466 18.6134 10.9463 19.7169 10.2038 20.3356C9.46133 20.9544 8.35785 20.8541 7.73911 20.1116C6.8066 18.9926 6.16683 17.2225 6.16683 15.4913H5.00016ZM22.2729 3.26929C22.4211 3.4916 22.5002 3.7528 22.5002 4.01998V17.6292C22.5002 18.3766 21.8943 18.9825 21.1468 18.9825C20.8796 18.9825 20.6184 18.9034 20.3961 18.7552L15.8686 15.7369C15.7213 15.6387 15.674 15.5961 15.6284 15.5409C15.5827 15.4856 15.5506 15.4257 15.53 15.3571C15.5135 15.3022 15.5043 15.2509 15.5013 15.142L15.5002 6.60068C15.5002 6.42371 15.5094 6.36075 15.53 6.2921C15.5506 6.22345 15.5827 6.16357 15.6284 6.10832C15.674 6.05308 15.7213 6.01049 15.8686 5.91232L20.3961 2.89394C21.018 2.47934 21.8583 2.64739 22.2729 3.26929Z",
    fill: "#322267"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsMenu);
export default __webpack_public_path__ + "static/media/blogs_menu.08e8067542152072fc4f8c8d879ec0ab.svg";
export { ForwardRef as ReactComponent };